module.exports = __webpack_public_path__ + "assets/icons/ic_vpn_key_24px.svg";